var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.$store.state.loading)?_c('div',[_c('v-row',{staticClass:"fill-height my-6",attrs:{"align":"center","justify":"center"}},[_c('v-progress-circular',{attrs:{"indeterminate":"","color":"grey","size":"40"}})],1)],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }